export default "__VITE_ASSET__BiLI3MfL__"